import React, { useState } from 'react';
import {
	Box,
	Typography,
	Modal,
	IconButton,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { styled } from '@mui/material/styles';
import { connect } from 'react-redux';
import { DARK_MODE } from '../../constants';

// Styled components for the new design
const ModalContainer = styled(Box)({
	position: 'fixed',
	top: 0,
	left: 0,
	right: 0,
	bottom: 0,
	backgroundColor: 'rgba(0, 0, 0, 0.5)',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	zIndex: 9999,
});

const OuterContainer = styled(Box)(({ themeMode }) => ({
	position: 'relative',
	width: '1327.26px',
	height: '704.31px',
	background: themeMode === DARK_MODE ? '#151A1F' : '#F2F2F2',
	borderRadius: '48px',
}));

const InnerContainer = styled(Box)(({ themeMode }) => ({
	position: 'absolute',
	width: '1233.54px',
	height: '631.37px',
	left: '46.72px',
	top: '72.94px',
	background: themeMode === DARK_MODE 
		? 'linear-gradient(115.48deg, #1A2127 31.9%, #151A1F 100%)'
		: 'linear-gradient(115.48deg, #DFDFDF 31.9%, #F1F1F1 99.99%)',
	borderRadius: '24px',
}));

const SideBar = styled(Box)(({ themeMode }) => ({
	position: 'absolute',
	width: '19.52px',
	height: '531.51px',
	background: themeMode === DARK_MODE ? '#262626' : '#ADACA8',
}));

const LeftSideBar = styled(SideBar)({
	left: '0px',
	top: '20.9px',
	borderRadius: '0px 8px 8px 0px',
});

const RightSideBar = styled(SideBar)({
	right: '0px',
	top: '20.9px',
	borderRadius: '8px 0px 0px 8px',
});

const Title = styled(Typography)(({ themeMode }) => ({
		position: 'absolute',
	width: '184.1px',
	height: '37.07px',
	left: '78.08px',
	top: '56.17px',
	fontFamily: "'JLR Emeric', sans-serif",
	fontStyle: 'normal',
	fontWeight: 600,
	fontSize: '30px',
	lineHeight: '37px',
	color: themeMode === DARK_MODE ? '#FFFFFF' : '#202020',
		display: 'flex',
	alignItems: 'center',
}));

const CloseButton = styled(IconButton)({
	position: 'absolute',
	right: '20px',
	top: '20px',
	minWidth: 'auto',
	padding: '8px',
	color: '#ACACAC',
	'&:hover': {
		backgroundColor: 'rgba(0, 0, 0, 0.1)',
	},
});

const SummaryTable = styled(Table)({
	position: 'absolute',
	width: '1176.61px',
	height: '84.16px',
	left: '78.08px',
	top: '126.3px',
});

const SummaryTableHead = styled(TableHead)({
	position: 'absolute',
	width: '1176.61px',
	height: '43.08px',
	left: '0px',
	top: '0px',
});

const SummaryTableBody = styled(TableBody)({
	position: 'absolute',
	width: '1088.72px',
	height: '22.04px',
	left: '10.24px',
	top: '62.11px',
});

const SummaryTableRow = styled(TableRow)({
	position: 'absolute',
	width: '1088.72px',
	height: '22.04px',
	left: '0px',
	top: '0px',
});

const SummaryTableCell = styled(TableCell)(({ themeMode }) => ({
	position: 'absolute',
	fontFamily: "'Uni Neue', sans-serif",
	fontStyle: 'normal',
	fontWeight: 800,
	fontSize: '20px',
	lineHeight: '27px',
	color: themeMode === DARK_MODE ? '#FFFFFF' : '#242424',
	border: 'none',
	padding: 0,
}));

const SummaryHeaderCell = styled(TableCell)(({ themeMode }) => ({
	position: 'absolute',
	fontFamily: "'Uni Neue', sans-serif",
	fontStyle: 'normal',
	fontWeight: 700,
	fontSize: '20px',
	lineHeight: '27px',
	color: themeMode === DARK_MODE ? '#FFFFFF' : '#242424',
	border: 'none',
	padding: 0,
}));

const SeparatorLine = styled(Box)(({ themeMode }) => ({
	position: 'absolute',
	width: '1176.61px',
	height: '0px',
	left: '78.08px',
	top: '169.38px',
	border: `1px solid ${themeMode === DARK_MODE ? '#404040' : '#B0B0B0'}`,
}));

const DetailsTable = styled(Table)({
	position: 'absolute',
	width: '1214.99px',
	height: '323.6px',
	left: '78.08px',
	top: '240.51px',
});

const DetailsTableHead = styled(TableHead)({
	position: 'absolute',
	width: '1195.05px',
	height: '42.08px',
	left: '0px',
	top: '0px',
});

const DetailsTableBody = styled(TableBody)({
	position: 'absolute',
	width: '1214.99px',
	height: '281.52px',
	left: '0px',
	top: '59.11px',
});

const DetailsTableRow = styled(TableRow)(({ index, themeMode }) => ({
	position: 'absolute',
	width: '1214.99px',
	height: '39.07px',
	left: '0px',
	top: `${index * 39.07}px`,
	backgroundColor: getRowBackgroundColor(index, themeMode),
}));

const DetailsTableCell = styled(TableCell)(({ themeMode, status }) => ({
	position: 'absolute',
	fontFamily: "'Uni Neue', sans-serif",
	fontStyle: 'normal',
	fontWeight: 800,
	fontSize: '20px',
	lineHeight: '27px',
	color: status ? getStatusColor(status) : (themeMode === DARK_MODE ? '#FFFFFF' : '#202020'),
	border: 'none',
	padding: 0,
}));

const DetailsHeaderCell = styled(TableCell)(({ themeMode }) => ({
	position: 'absolute',
	fontFamily: "'Uni Neue', sans-serif",
	fontStyle: 'normal',
	fontWeight: 700,
	fontSize: '20px',
	lineHeight: '27px',
	color: themeMode === DARK_MODE ? '#FFFFFF' : '#202020',
	border: 'none',
	padding: 0,
}));

const SortIcon = styled(KeyboardArrowUpIcon)({
	position: 'absolute',
	height: '20px',
	background: '#202020',
	transform: 'rotate(-90deg)',
});

// Helper functions
const getRowBackgroundColor = (index, themeMode) => {
	if (themeMode === DARK_MODE) {
		return 'transparent';
	}
	const colors = ['#E8F5E8', '#E8F5E8', '#FFE8E8', '#FFF4E8', '#FFF4E8'];
	return colors[index] || 'transparent';
};

const getStatusColor = (status) => {
	switch (status) {
		case 'Validated':
			return '#229104';
		case 'Skipped':
			return '#CB1D49';
		case 'Pending':
			return '#ECB040';
		default:
			return '#202020';
	}
};


const ReportModal = ({
	open,
	handleClose,
	rows,
	columns,
	defaultColumns,
	title,
	subtitle,
	scannableParts,
	themeMode,
}) => {
	if (!open) return null;

	const reportData = scannableParts ? {
		summary: {
			serialNumber: rows?.[0]?.serialNumber || '-',
			casePackNumber: rows?.[0]?.parentPartNumber || '-',
			casePackDescription: rows?.[0]?.parentPartDescription || '-',
		},
		details: scannableParts.map(part => ({
			partName: part.familyName || '-',
			partNumber: part.partNumber || '-',
			partDescription: part.partDescription || '-',
			qty: part.quantity || '1',
			serialNumber: part.scanJobResults?.[0]?.scannedSerialNumber || '-',
			status: part.scanJobResults?.length >= part.quantity ? 'Validated' : 
					part.skipReason ? 'Skipped' : 'Pending',
		}))
	} : {
		summary: {
			serialNumber: '-',
			casePackNumber: '-',
			casePackDescription: '-',
		},
		details: []
	};

	return (
		<ModalContainer>
			<OuterContainer themeMode={themeMode}>
				<InnerContainer themeMode={themeMode}>
					<LeftSideBar themeMode={themeMode} />
					<RightSideBar themeMode={themeMode} />
					
					<Title themeMode={themeMode}>View Reports</Title>
					
					<CloseButton onClick={handleClose}>
						<CloseIcon />
					</CloseButton>
					
					{/* Summary Table */}
					<SummaryTable>
						<SummaryTableHead>
							<TableRow>
								<SummaryHeaderCell 
									themeMode={themeMode}
									sx={{ left: '7.17px', top: '0px', width: '241.48px' }}
								>
									VIN
								</SummaryHeaderCell>
								<SummaryHeaderCell 
									themeMode={themeMode}
									sx={{ left: '394.84px', top: '0px', width: '216.2px' }}
								>
									Case Pack Number
								</SummaryHeaderCell>
								<SummaryHeaderCell 
									themeMode={themeMode}
									sx={{ left: '822.9px', top: '0px', width: '226.13px' }}
								>
									Case Pack Description
								</SummaryHeaderCell>
							</TableRow>
						</SummaryTableHead>
						<SummaryTableBody>
							<SummaryTableRow>
								<SummaryTableCell 
									themeMode={themeMode}
									sx={{ left: '0px', top: '0px', width: '238.41px' }}
								>
									{reportData.summary.serialNumber}
								</SummaryTableCell>
								<SummaryTableCell 
									themeMode={themeMode}
									sx={{ left: '388.48px', top: '0px', width: '221.63px' }}
								>
									{reportData.summary.casePackNumber}
								</SummaryTableCell>
								<SummaryTableCell 
									themeMode={themeMode}
									sx={{ left: '815.88px', top: '0px', width: '273.2px' }}
								>
									{reportData.summary.casePackDescription}
								</SummaryTableCell>
							</SummaryTableRow>
						</SummaryTableBody>
					</SummaryTable>
					
					<SeparatorLine themeMode={themeMode} />
					
					{/* Details Table */}
					<DetailsTable>
						<DetailsTableHead>
							<TableRow>
								<DetailsHeaderCell 
									themeMode={themeMode}
									sx={{ left: '9.42px', top: '0px', width: '181.09px' }}
								>
									Part Name
									<SortIcon sx={{ left: '26.84%', top: 'calc(50% - 20px/2 - 108.24px)' }} />
								</DetailsHeaderCell>
								<DetailsHeaderCell 
									themeMode={themeMode}
									sx={{ left: '256.25px', top: '0px', width: '168.51px' }}
								>
									Part Number
									<SortIcon sx={{ left: '40.28%', top: 'calc(50% - 20px/2 - 108.24px)' }} />
								</DetailsHeaderCell>
								<DetailsHeaderCell 
									themeMode={themeMode}
									sx={{ left: '451.35px', top: '0px', width: '168.51px' }}
								>
									Part Description
									<SortIcon sx={{ left: '51.8%', top: 'calc(50% - 20px/2 - 108.24px)' }} />
								</DetailsHeaderCell>
								<DetailsHeaderCell 
									themeMode={themeMode}
									sx={{ left: '674.47px', top: '0px', width: '62.03px' }}
								>
									Qty
									<SortIcon sx={{ left: '57.69%', top: 'calc(50% - 20px/2 - 108.24px)' }} />
								</DetailsHeaderCell>
								<DetailsHeaderCell 
									themeMode={themeMode}
									sx={{ left: '785.52px', top: '0px', width: '168.51px' }}
								>
									Serial Number
									<SortIcon sx={{ left: '68.99%', top: 'calc(50% - 20px/2 - 108.24px)' }} />
								</DetailsHeaderCell>
								<DetailsHeaderCell 
									themeMode={themeMode}
									sx={{ left: '1026.65px', top: '0px', width: '168.51px' }}
								>
									Status
								</DetailsHeaderCell>
								</TableRow>
						</DetailsTableHead>
						<DetailsTableBody>
							{reportData.details.map((row, index) => (
								<DetailsTableRow key={index} index={index} themeMode={themeMode}>
									<DetailsTableCell 
										themeMode={themeMode}
										sx={{ left: '9.8px', top: '0px', width: '212px' }}
									>
										{row.partName}
									</DetailsTableCell>
									<DetailsTableCell 
										themeMode={themeMode}
										sx={{ left: '256.25px', top: '0px', width: '188.46px' }}
									>
										{row.partNumber}
									</DetailsTableCell>
									<DetailsTableCell 
										themeMode={themeMode}
										sx={{ left: '451.35px', top: '0px', width: '188.46px' }}
									>
										{row.partDescription}
									</DetailsTableCell>
									<DetailsTableCell 
										themeMode={themeMode}
										sx={{ left: '674.47px', top: '0px', width: '69.04px' }}
									>
										{row.qty}
									</DetailsTableCell>
									<DetailsTableCell 
										themeMode={themeMode}
										sx={{ left: '785.52px', top: '0px', width: '188.46px' }}
									>
										{row.serialNumber}
									</DetailsTableCell>
									<DetailsTableCell 
										themeMode={themeMode}
										status={row.status}
										sx={{ left: '1026.65px', top: '0px', width: '188.46px' }}
									>
										{row.status}
									</DetailsTableCell>
								</DetailsTableRow>
							))}
						</DetailsTableBody>
					</DetailsTable>
				</InnerContainer>
			</OuterContainer>
		</ModalContainer>
	);
};

const mapStateToProps = state => ({
	themeMode: state.theme.themeMode,
});

export default connect(mapStateToProps)(ReportModal);
